import React from 'react'
import Topbar from '../components/top-bar'
import Home from '../pages/Home'

interface IMainLayout {
    children?: React.ReactNode
}

const MainLayout: React.FC<IMainLayout> = ({ children }) => {
    return (
        <div className='main-container'>

            <Topbar />

            <main className='w-full sm:px-4 sm:pt-10 sm:pb-20 flex items-start justify-center'>
                {children ? children : <Home />}
            </main>
        </div>
    )
}

export default MainLayout
